module.exports = __webpack_public_path__ + "static/media/banner3-PR-persona.49e5e8c8.png";